"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstimatedValues$ = exports.EstimatedValues$outboundSchema = exports.EstimatedValues$inboundSchema = void 0;
exports.estimatedValuesToJSON = estimatedValuesToJSON;
exports.estimatedValuesFromJSON = estimatedValuesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const fastapikrakenendpointsstatsmodelssaleslocalauthoritygetestimatedvaluesresponsesstatslatestestimate_js_1 = require("./fastapikrakenendpointsstatsmodelssaleslocalauthoritygetestimatedvaluesresponsesstatslatestestimate.js");
const pricechangesestimatedvalues_js_1 = require("./pricechangesestimatedvalues.js");
const statsdelta_js_1 = require("./statsdelta.js");
/** @internal */
exports.EstimatedValues$inboundSchema = z.object({
    delta: statsdelta_js_1.StatsDelta$inboundSchema,
    latest_estimate: fastapikrakenendpointsstatsmodelssaleslocalauthoritygetestimatedvaluesresponsesstatslatestestimate_js_1.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesStatsLatestEstimate$inboundSchema,
    values: z.array(pricechangesestimatedvalues_js_1.PriceChangesEstimatedValues$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "latest_estimate": "latestEstimate",
    });
});
/** @internal */
exports.EstimatedValues$outboundSchema = z.object({
    delta: statsdelta_js_1.StatsDelta$outboundSchema,
    latestEstimate: fastapikrakenendpointsstatsmodelssaleslocalauthoritygetestimatedvaluesresponsesstatslatestestimate_js_1.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesStatsLatestEstimate$outboundSchema,
    values: z.array(pricechangesestimatedvalues_js_1.PriceChangesEstimatedValues$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        latestEstimate: "latest_estimate",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var EstimatedValues$;
(function (EstimatedValues$) {
    /** @deprecated use `EstimatedValues$inboundSchema` instead. */
    EstimatedValues$.inboundSchema = exports.EstimatedValues$inboundSchema;
    /** @deprecated use `EstimatedValues$outboundSchema` instead. */
    EstimatedValues$.outboundSchema = exports.EstimatedValues$outboundSchema;
})(EstimatedValues$ || (exports.EstimatedValues$ = EstimatedValues$ = {}));
function estimatedValuesToJSON(estimatedValues) {
    return JSON.stringify(exports.EstimatedValues$outboundSchema.parse(estimatedValues));
}
function estimatedValuesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.EstimatedValues$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'EstimatedValues' from JSON`);
}
//# sourceMappingURL=estimatedvalues.js.map